module.exports = __webpack_public_path__ + "img/yfh-thumb5.233fbe8e.png";